export default {
    bindings: {
        'event': '<',
        'time': '<',
        'getAvailability': '&'
    },
    controller: 'activityAddController',
    template: require('../views/activity.add.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/activity.add.component.js